// Error code -> translation key for checkout (COI-779, ADR-0032).
//
// Generated from the [errors] table of internal/buy/locales/en.toml, whose
// copy is in turn the approved SHORT form of the message from the checkout
// error catalog (the "Checkout Error Catalog Documentation" Confluence page,
// mirrored in internal/buy/buy_errorcatalog). A toast and the server-rendered
// card for the same condition therefore say the same thing, the toast just
// says less of it — never less than the part that carries safety.
//
// A code that is absent renders the canonical message the server sent — that
// is the documented fallback, not a gap. Codes checkout has no approved
// presentation for are deliberately absent.

import { createErrorResolver } from "../../../../global/js/errorCodes.js";

export const ERROR_TRANSLATION_KEYS = {
  AUTH_ACCOUNT_UNAVAILABLE: "errors.auth_account_unavailable",
  AUTH_EMAIL_NOT_RECOGNIZED: "errors.auth_email_not_recognized",
  AUTH_INVALID_TOKEN: "errors.auth_invalid_token",
  AUTH_OTP_EXPIRED: "errors.auth_otp_expired",
  AUTH_OTP_INVALID: "errors.auth_otp_invalid",
  AUTH_OTP_LOCKED: "errors.auth_otp_locked",
  AUTH_OTP_RATE_LIMITED: "errors.auth_otp_rate_limited",
  AUTH_OTP_SEND_FAILED: "errors.auth_otp_send_failed",
  AUTH_PASSKEY_CANCELLED: "errors.auth_passkey_cancelled",
  AUTH_SESSION_EXPIRED: "errors.auth_session_expired",
  AUTH_UNAUTHENTICATED: "errors.auth_unauthenticated",
  INTERNAL: "errors.internal",
  PAYMENT_ALREADY_COMPLETED: "errors.payment_already_completed",
  PAYMENT_BALANCE_UNAVAILABLE: "errors.payment_balance_unavailable",
  PAYMENT_CHECKOUT_UNAVAILABLE: "errors.payment_checkout_unavailable",
  PAYMENT_DECLINED_IN_WALLET: "errors.payment_declined_in_wallet",
  PAYMENT_DEPOSIT_ADDRESS_EXPIRED: "errors.payment_deposit_address_expired",
  PAYMENT_DEPOSIT_SETUP_FAILED: "errors.payment_deposit_setup_failed",
  PAYMENT_DEPOSIT_SHORT: "errors.payment_deposit_short",
  PAYMENT_FAILED: "errors.payment_failed",
  PAYMENT_IDEMPOTENCY_CONFLICT: "errors.payment_idempotency_conflict",
  PAYMENT_INSUFFICIENT_BALANCE: "errors.payment_insufficient_balance",
  PAYMENT_LINK_EXPIRED: "errors.payment_link_expired",
  PAYMENT_METHOD_UNAVAILABLE: "errors.payment_method_unavailable",
  PAYMENT_NETWORK_SWITCH_REQUIRED: "errors.payment_network_switch_required",
  PAYMENT_NETWORK_UNAVAILABLE: "errors.payment_network_unavailable",
  PAYMENT_NOT_FOUND: "errors.payment_not_found",
  PAYMENT_NOT_PERMITTED: "errors.payment_not_permitted",
  PAYMENT_PENDING: "errors.payment_pending",
  PAYMENT_PRICING_UNAVAILABLE: "errors.payment_pricing_unavailable",
  PAYMENT_REVERTED_ON_CHAIN: "errors.payment_reverted_on_chain",
  PAYMENT_STATUS_UNCONFIRMED: "errors.payment_status_unconfirmed",
  PAYMENT_UNSUPPORTED_NETWORK: "errors.payment_unsupported_network",
  PAYMENT_WALLET_CONNECT_CANCELLED: "errors.payment_wallet_connect_cancelled",
  PAYMENT_WALLET_CONNECT_FAILED: "errors.payment_wallet_connect_failed",
  SIGNER_CHALLENGE_EXPIRED: "errors.signer_challenge_expired",
  SIGNER_REJECTED: "errors.signer_rejected",
  SIGNER_UNAVAILABLE: "errors.signer_unavailable",
  SIGNER_WALLET_SETUP_FAILED: "errors.signer_wallet_setup_failed",
  VALIDATION_INVALID_EMAIL: "errors.validation_invalid_email",
  VALIDATION_INVALID_FIELD: "errors.validation_invalid_field",
  VALIDATION_INVALID_REQUEST: "errors.validation_invalid_request",
};

// translateError(source, fallback) resolves an error envelope, an Error thrown
// by HttpService, or a parsed error body into the copy to display.
export const translateError = createErrorResolver(ERROR_TRANSLATION_KEYS);
